// extracted by mini-css-extract-plugin
export default {"section":"Companies_section__HLqN0","title":"Companies_title__eQTqD","carousel":"Companies_carousel__UFzMO","slideImage":"Companies_slideImage__O7apt"};